import { render } from "./nuevoPedidoSubAgente.vue?vue&type=template&id=2ebcf33e&scoped=true"
import script from "./nuevoPedidoSubAgente.vue?vue&type=script&lang=js"
export * from "./nuevoPedidoSubAgente.vue?vue&type=script&lang=js"

import "./nuevoPedidoSubAgente.vue?vue&type=style&index=0&id=2ebcf33e&scoped=true&lang=css"
import "./nuevoPedidoSubAgente.vue?vue&type=style&index=1&id=2ebcf33e&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebcf33e"]])

export default __exports__